import { useCallback } from 'react'
import { generatePath, useLocation, useNavigate, useParams } from 'react-router-dom'

import { useUpdateSettings } from '@queries/Account'
import useStore from '@src/store'
import useGetAccount from './useGetAccount'

import {
  OrganizationIntegration as OrganizationIntegrationResponse,
  OrganizationListItem,
  OrganizationSettings,
} from '@models/ApproveitAccounting'
import routes from '@src/Routes/routes'
import { AccountingIntegrationVendor } from '@type/common'
import { OrganizationIntegration } from '@models/Organization'

export const getIntegrationBySetting = (
  organizationIntegration: OrganizationIntegrationResponse | null,
  settings: OrganizationSettings | null,
) => {
  const integration: OrganizationIntegration | undefined = organizationIntegration
    ? {
        tenantId: organizationIntegration.tenant_id,
        integrationId: organizationIntegration.integration_id,
      }
    : undefined
  let integrationName: AccountingIntegrationVendor | undefined
  if (settings?.xero_sync_enabled) {
    integrationName = AccountingIntegrationVendor.xero
  }
  if (settings?.softledger_sync_enabled) {
    integrationName = AccountingIntegrationVendor.softledger
  }
  if (settings?.quickbooks_sync_enabled) {
    integrationName = AccountingIntegrationVendor.quickbooks
  }
  return { integration, integrationName }
}

export const useSwitchActiveOrganization = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ id: string }>()
  const switchOrganization = useStore.use.switchOrganization()
  const { mutateAsync: updateSettings } = useUpdateSettings()
  const user = useGetAccount()

  const setOrganization = (organization: Pick<OrganizationListItem, 'id' | 'name' | 'integration' | 'settings'>) => {
    const { integration, integrationName } = getIntegrationBySetting(organization.integration, organization.settings)
    switchOrganization(organization.id, organization.name, integration, integrationName)
    if (user?.settings.active_organization !== organization.id) {
      updateSettings({
        active_organization: organization.id,
      })
    }
    if (params.id && location.pathname === generatePath(routes.private.organization, { id: params.id })) {
      navigate(generatePath(routes.private.organization, { id: organization.id }))
    }
  }

  return useCallback(setOrganization, [user?.settings.active_organization, location])
}
